<template>
  <v-text-field
    :ref="tfRef"
    class="mask-phone"
    :value="value || '+77_________'"
    :rules="$attrs.readonly ? [] : [...(rules || []), phoneRule]"
    @input="handleInput"
    @keyup.enter="$emit('enter')"
    v-bind="$attrs"
    autocomplete="off"
  />
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import Inputmask from "inputmask";

type NullableElement = HTMLElement | null;
const MIN_PHONE_LENGTH = 9;

@Component
export default class extends Vue {
  @Prop(String) value!: string;
  @Prop(Boolean) required!: boolean;

  tfRef = "tfRef";

  get rules() {
    if (!this.$attrs.rules) return [];
    return (this.$attrs.rules as any).map((rFn: any) => () => rFn(this.value));
  }

  focus() {
    this.$nextTick((this.$refs[this.tfRef] as HTMLElement).focus);
  }
  phoneRule(value: string) {
    if (value === "+77_________") return true;
    return (
      !value || (!this.isValidPhone(value) && this.$t("invalidPhone")) || true
    );
  }
  isValidPhone(v: string) {
    const value = v || this.value;
    return value && !value.includes("_") && value.length > MIN_PHONE_LENGTH;
  }
  handleInput(v: string) {
    this.$emit("input", v === "+77_________" ? "" : v);
  }

  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    const input: NullableElement = this.$el.querySelector(
      ".v-text-field__slot input"
    );
    if (!input) return;
    Inputmask({
      regex: String.raw`^\+7\(7\d{2}\)-\d{3}-\d{4}$`,
      autoUnmask: true,
      onUnMask: function(maskedValue: string) {
        return maskedValue.replace(/[()-]/g, "");
      },
      onBeforeMask: function(pastedValue: string) {
        pastedValue = pastedValue
          .replace(/\s/g, "")
          .replace(/[&/\\#,+()$~%.'":*?<>{}-]/g, "");
        if (isNaN(Number(pastedValue))) {
          vm.$emit("input", "");
          return "";
        }
        if (pastedValue.length > MIN_PHONE_LENGTH) {
          const cut = pastedValue.substring(
            pastedValue.length - MIN_PHONE_LENGTH
          );
          vm.$emit("input", `+77${cut}`);
          return cut;
        } else {
          return pastedValue;
        }
      },
    }).mask(input);
  }
}
</script>
<style></style>
